/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { of, throwError } from "rxjs";
import { AdvancedFilters } from "../../../../models/http/dashboard/advanced-filters.model";
import { ApplicationError } from "../../../../models/ui/application-error.model";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import { GET_WORST_10_APPS_RESPONSE, GET_WORST_10_LAYERS_RESPONSE } from "./dashboard-impact.db";

const CLASS_NAME = "DashboardImpact";

export class DashboardImpact {
	public static getWorst10Layers(options: HttpRequestOptions) {
		const filters = options.body as AdvancedFilters | undefined;

		if (!filters?.startDate || !filters.endDate)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						CLASS_NAME,
						"getWorst10Layers"
					)
			);

		return of(GET_WORST_10_LAYERS_RESPONSE);
	}

	public static getWorst10Apps(options: HttpRequestOptions) {
		const filters = options.body as AdvancedFilters | undefined;

		if (!filters?.startDate || !filters.endDate)
			return throwError(
				() =>
					new ApplicationError(
						"Missing required parameters",
						CLASS_NAME,
						"getWorst10Apps"
					)
			);

		return of(GET_WORST_10_APPS_RESPONSE);
	}

	public static downloadAsCsv(options: HttpRequestOptions) {
		// const { params, pathParams } = options;

		// const httpParams = params as HttpParams;

		// if (!httpParams)
		// 	return throwError(
		// 		() =>
		// 			new ApplicationError(
		// 				"No params provided",
		// 				this.constructor.name,
		// 				this.downloadAsCsv.name
		// 			)
		// 	);

		// const tenantId = httpParams.get("tenantId");

		// if (!tenantId)
		// 	return throwError(
		// 		() =>
		// 			new ApplicationError(
		// 				"Missing required parameters",
		// 				this.constructor.name,
		// 				this.downloadAsCsv.name
		// 			)
		// 	);

		// const fileId = pathParams?.["fileId"];

		// if (!fileId)
		// 	return throwError(
		// 		() =>
		// 			new ApplicationError(
		// 				"No file id provided",
		// 				this.constructor.name,
		// 				this.downloadAsCsv.name
		// 			)
		// 	);

		return of("");
	}
}
